import React from "react";
import "../../Styles/certified/gyan.css";

export default function Finzly() {
  return (
    <>
      <div className="gyan-certified-details-section">
        <div className="gyan-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="gyan-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="gyan-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="gyan-certified-badge"
            />
            <div className="gyan-certified-company-names">
              <a href="https://www.gyanmatrix.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/gyan/gyan.png"
                alt="Walkzero Logo"
                className="gyan-certified-company-logo"
              />
            </a>
              <h1 className="gyan-certified-full-name">
              GyanMatrix Technologies Pvt ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="gyan-certified-details-right">
            <img
              src="/assets/gyan/gyan_2.jpg"
              alt="Finzly Office"
              className="gyan-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="gyan-certified-description">
          <h2>
            Why  GyanMatrix Technologies Pvt ltd is an Outstanding Workplaces
          </h2>
          <p>
          We are an AI-driven software company specializing in building Global Capability Centers (GCCs) and delivering innovative technology solutions. Our employee-first culture is built on trust, transparency, and collaboration. With a flat hierarchy, every individual has direct access to leadership, encouraging open communication and faster decision-making. We foster a supportive environment where everyone is empowered to share ideas, seek guidance, and contribute without barriers. Our teams work together with a shared purpose—supporting one another to achieve common organizational goals. We believe our greatest strength lies in our people, and their collective success drives the organization's success.


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="gyan-certified-info-cards">
          <div className="gyan-certified-info-card">
            <div className="gyan-certified-info-title">COMPANY SIZE</div>
            <div className="gyan-certified-info-value">40+ Employees</div>
          </div>
          <div className="gyan-certified-info-card">
            <div className="gyan-certified-info-title">INDUSTRY</div>
            <div className="gyan-certified-info-value"> Information Technology 

</div>
          </div>
          <div className="gyan-certified-info-card">
            <div className="gyan-certified-info-title">CONNECT</div>
            <div className="gyan-certified-info-icons">
              <span className="gyan-certified-icon-round">
                <a href="https://www.gyanmatrix.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="gyan-certified-icon-round">
                <a href="https://www.linkedin.com/company/gyanmatrix/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="gyan-certified-icon-round">
                <a href="https://www.facebook.com/gyanmatrix/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="gyan-certified-info-card">
            <div className="gyan-certified-info-title">LOCATION (HQ)</div>
            <div className="gyan-certified-info-value">Bangalore,Karnataka </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="gyan-certified-recognition-section">
          <h2 className="gyan-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="gyan-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="gyan-certified-recognition-image"
            />
          </div>
          <div className="gyan-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="gyan-certified-life-section">
          <h2 className="gyan-certified-life-title">
            Life at GyanMatrix Technologies Pvt ltd
          </h2>
          <div className="gyan-certified-life-gallery">
            <div className="gyan-certified-life-col">
              <img src="/assets/gyan/gyan_1.jpg" alt="Office 1" className="gyan-certified-life-img" />
              <img src="/assets/gyan/gyan_2.jpg" alt="Team 1" className="gyan-certified-life-img" />
            </div>
            <div className="icom-certified-life-col gyan-certified-life-center">
              <img src="/assets/gyan/gyan_6.png" alt="Main Office" className="gyan-certified-life-img gyan-certified-life-img-large" />
            </div>
            <div className="gyan-certified-life-col">
              <img src="/assets/gyan/gyan_3.jpg" alt="Office 2" className="gyan-certified-life-img" />
              <img src="/assets/gyan/gyan_4.jpg" alt="Team 2" className="gyan-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
